import * as React from 'react'

const IconText = (props) => (
  <svg
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 300 300'
    width={300}
    height={300}
    {...props}
  >
    <path d='M99 195a8.39 8.39 0 0 1-5.95-2.55l-36.53-36.5a8.22 8.22 0 0 1 0-11.9l36.54-36.54A8.41 8.41 0 0 1 105 119.4l-30.21 30.17L105 179.74a8.22 8.22 0 0 1 0 11.9 6.85 6.85 0 0 1-6 3.36ZM201.42 195a8.39 8.39 0 0 1-5.95-2.55 8.22 8.22 0 0 1 0-11.9l30.17-30.17-30.17-30.17a8.41 8.41 0 1 1 11.9-11.9l36.54 36.54a8.22 8.22 0 0 1 0 11.9l-36.54 36.54a12.28 12.28 0 0 1-5.95 1.71ZM130.88 212a7.23 7.23 0 0 1-3-.42 8.67 8.67 0 0 1-5.1-11L161.9 93.91a8.6 8.6 0 0 1 16.1 5.95l-39 106.65a8.71 8.71 0 0 1-8.12 5.49Z' />
    <path d='M150 0a150 150 0 1 0 150 150c.42-82.86-67.14-150-150-150Zm0 283.85a133.85 133.85 0 0 1 0-267.7c73.94 0 134.28 59.91 133.85 133.85A133.84 133.84 0 0 1 150 283.85Z' />
  </svg>
)

export default IconText
